import angular from 'angular';
import Promise from 'bluebird';

import signUpTemplate from 'components/signUp/signUp.html';
import loginTemplate from 'components/login/login.html';
import forgotPasswordTemplate from 'components/forgotPassword/forgotPassword.html';
import changePasswordTemplate from 'components/changePassword/changePassword.html';
import noOrganizationsTemplate from 'components/noOrganizations/noOrganizations.html';
import noVenuesTemplate from 'components/noVenues/noVenues.html';
import notFoundTemplate from 'components/notFound/notFound.html';
import appTemplate from 'components/app/app.html';
import selectOrganizationTemplate from 'components/selectOrganization/selectOrganization.html';
import stripeConnectSuccessTemplate from 'components/stripeConnectSuccess/stripeConnectSuccess.html';
import accountSetupTemplate from 'components/accountSetup/accountSetup.html';
import accountTemplate from 'components/account/account.html';
import accountProfileTemplate from 'components/accountProfile/accountProfile.html';
import organizationTemplate from 'components/organization/organization.html';
//settings
import settingsTemplate from 'components/settings/settings.html';
import settingsOrganizationTemplate from 'components/settingsOrganization/settingsOrganization.html';
import settingsAttributionsTemplate from 'components/settingsAttributions/settingsAttributions.html';
import settingsMicroSiteConfigsTemplate from 'components/settingsMicroSiteConfigs/settingsMicroSiteConfigs.html';
import settingsMicroSiteConfigEditTemplate from 'components/settingsMicroSiteConfigEdit/settingsMicroSiteConfigEdit.html';
import settingsIntegrationsTemplate from 'components/settingsIntegrations/settingsIntegrations.html';
import settingsStaffTemplate from 'components/settingsStaff/settingsStaff.html';
import settingsServersTemplate from 'components/settingsServers/settingsServers.html';
import settingsPromotersTemplate from 'components/settingsPromoters/settingsPromoters.html';
import settingsVenueTemplate from 'components/settingsVenue/settingsVenue.html';
import settingsVenueSettingsTemplate from 'components/settingsVenueSettings/settingsVenueSettings.html';
import settingsVenueBillingTemplate from 'components/settingsVenueBilling/settingsVenueBilling.html';
import settingsVenueBusinessHoursTemplate from 'components/settingsVenueBusinessHours/settingsVenueBusinessHours.html';
import settingsVenueFloorplansTemplate from 'components/settingsVenueFloorplans/settingsVenueFloorplans.html';
import settingsVenueWidgetTemplate from 'components/settingsVenueWidget/settingsVenueWidget.html';
import settingsVenueScheduleInventoryTemplate from 'components/settingsVenueScheduleInventory/settingsVenueScheduleInventory.html';
import settingsVenueReportScheduleTemplate from 'components/settingsVenueReportSchedule/settingsVenueReportSchedule.html';
//
import unauthorizedTemplate from 'components/unauthorized/unauthorized.html';
//manage
import manageTemplate from 'components/manage/manage.html';
import manageDashboard from 'components/manageDashboard/template.html';
import manageDaySettingsTemplate from 'components/manageDaySettings/template.html';
import manageReservationsTemplate from 'components/manageReservations/manageReservations.html';
import manageGuestlistsTemplate from 'components/manageGuestlists/manageGuestlists.html';
import manageInventoryTemplate from 'components/manageInventory/manageInventory.html';
import manageNotesTemplate from 'components/manageNotes/template.html';
import manageExportListTemplate from 'components/manageExportList/manageExportList.html';
//events
import eventsTemplate from 'components/events/events.html';
import createEventTemplate from 'components/createEvent/createEvent.html';
//event
import eventTemplate from 'components/event/event.html';
import eventSettingsTemplate from 'components/eventSettings/eventSettings.html';
import eventDashboardTemplate from 'components/eventDashboard/eventDashboard.html';
import eventWidgetsTemplate from 'components/eventWidgets/eventWidgets.html';
import eventWidgetTemplate from 'components/eventWidget/eventWidget.html';
import eventPromotersLinksTemplate from 'components/eventPromoterLinks/eventPromoterLinks.html';
import welcomeTemplate from 'components/welcome/welcome.html';
import performanceTemplate from 'components/performance/performance.html';
import performanceReservationsTemplate from 'components/performanceReservations/performanceReservations.html';
import performanceGuestListTemplate from 'components/performanceGuestList/performanceGuestList.html';
import performancePayoutsTemplate from 'components/performancePayouts/performancePayouts.html';
import performancePayoutTransactionsTemplate from 'components/performancePayoutTransactions/performancePayoutTransactions.html';
import performanceTallyTemplate from 'components/performanceTally/performanceTally.html';
import performanceExportListTemplate from 'components/performanceExportList/performanceExportList.html';
import customerDatabaseTemplate from 'components/customerDatabase/customerDatabase.html';
import customerEditTemplate from 'components/customerEdit/customerEdit.html';
import customerDataExportsTemplate from 'components/customerDataExports/customerDataExports.html';
import customerProfileTemplate from 'components/customerProfile/customerProfile.html';
import teamTemplate from 'components/team/team.html';
import teamExternalEditTemplate from 'components/teamExternalEdit/teamExternalEdit.html';
import teamStaffEditTemplate from 'components/teamStaffEdit/teamStaffEdit.html';
import teamServerEditTemplate from 'components/teamServerEdit/teamServerEdit.html';
//------- PROMOTER APP -------//
import promoterEventsTemplate from 'components/promoter/events/events.html';
import promoterSalesTemplate from 'components/promoter/sales/sales.html';
import promoterSalesReservationsTemplate from 'components/promoter/salesReservations/salesReservations.html';
import promoterSalesGuestlistsTemplate from 'components/promoter/salesGuestlists/salesGuestlists.html';

import SIDEBAR_LINKS from 'constants/sidebarLinks';

function configureRoutes($stateProvider) {
  $stateProvider
    .state('signup', {
      url: '/signup',
      template: signUpTemplate,
      authenticate: false
    })
    .state('login', {
      url: '/login?email&changedPasswordMsg',
      template: loginTemplate,
      authenticate: false
    })
    .state('forgotPassword', {
      url: '/forgot-password?email',
      template: forgotPasswordTemplate,
      controller: 'forgotPasswordCtrl',
      authenticate: false
    })
    .state('changePassword', {
      url: '/change-password?username&token',
      template: changePasswordTemplate,
      controller: 'changePasswordCtrl',
      authenticate: false
    })
    // ---------- Error States ---------- //
    .state('404', {
      url: '/404',
      template: notFoundTemplate,
      controller: 'notFoundCtrl',
      authenticate: false
    })
    .state('noOrganizations', {
      url: '/no-organizations',
      template: noOrganizationsTemplate,
      controller: 'noOrganizationsCtrl',
      authenticate: true
    })
    .state('noVenues', {
      url: '/no-venues',
      template: noVenuesTemplate,
      controller: 'noVenuesCtrl',
      authenticate: true
    })
    // ---------- App Routes ---------- //
    .state('app', {
      url: '/?signedUp',
      abstract: true,
      template: appTemplate,
      controller: 'appCtrl',
      authenticate: true,
      resolve: {
        currentUser: [
          'jsSdk.managementUser',
          'managementUserOrganizationMemberService',
          (managementUserService, managementUserOrganizationMemberService) => {
            return managementUserService.me()
              .then(() => managementUserOrganizationMemberService.getCurrentOrganizationMembers());
          }
        ]
      }
    })
    .state('app.accountSetup', {
      url: 'account-setup?signUpVersion',
      template: accountSetupTemplate,
      authenticate: true
    })
    .state('app.selectOrganization', {
      url: 'select-org?autoSelect',
      template: selectOrganizationTemplate,
      controller: 'selectOrganizationCtrl',
      controllerAs: 'vm',
      authenticate: true,
      resolve: {
        organizations: [
          '$state',
          '$q',
          'jsSdk.managementUser',
          'jsSdk.organization',
          'organizationService',
          ($state, $q, managementUserService, sdkOrganizationService, organizationService) => {
            const currentUser = managementUserService.getCurrentUser();

            if (!currentUser) {
              $state.go('login');
              return Promise.reject(new Error('not authenticated'));
            }

            return sdkOrganizationService.listByManagementUserId(currentUser.id, {
                limit: 1000
              })
              .then(organizations => {
                if (!organizations || !organizations.length) {
                  $state.go('noOrganizations');
                  return null;
                }

                organizationService.setCurrentOrganizations(organizations);

                return organizations;
              })
              .catch(error => {
                $state.go('404');

                return error;
              });
          }
        ]
      }
    })
    .state('app.stripeConnectSuccess', {
      url: 'stripe-connect?stripe_user_id&error&error_description',
      template: stripeConnectSuccessTemplate,
      controller: 'stripeConnectSuccessCtrl',
      controllerAs: 'vm',
      authenticate: true,
      resolve: {
        organizations: [
          '$state',
          '$q',
          'jsSdk.managementUser',
          'jsSdk.organization',
          'organizationService',
          ($state, $q, managementUserService, sdkOrganizationService, organizationService) => {
            const currentUser = managementUserService.getCurrentUser();

            if (!currentUser) {
              $state.go('login');
              return Promise.reject(new Error('not authenticated'));
            }

            return sdkOrganizationService.listByManagementUserId(currentUser.id)
              .then(organizations => {
                if (!organizations || !organizations.length) {
                  $state.go('noOrganizations');
                  return null;
                }

                organizationService.setCurrentOrganizations(organizations);

                return organizations;
              })
              .catch(error => {
                $state.go('404');

                return error;
              });
          }
        ]
      }
    })
    .state('app.organization', {
      url: 'org/:organizationId',
      abstract: true,
      template: organizationTemplate,
      authenticate: true,
      resolve: {
        organization: [
          '$stateParams',
          '$state',
          '$q',
          'jsSdk.organization',
          'organizationService',
          'venueService',
          ($stateParams, $state, $q, sdkOrganizationService, organizationService, venueService) => {
            return $q((resolve, reject) => {
              sdkOrganizationService.readById($stateParams.organizationId)
                .then(organization => {
                  organizationService.setCurrentOrganization(organization);

                  return organization;
                })
                .then(() => {
                  return venueService.getCurrentVenues();
                })
                .then(resolve)
                .catch(error => {
                  $state.go('404');

                  return reject(error);
                });
            });
          }
        ]
      },
      data: {
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToLogin
        }
      }
    })
    /**
     * ----------- Welcome -----------
     */
    .state('app.organization.welcome', {
      url: '/welcome',
      template: welcomeTemplate,
      authenticate: true,
      controller: 'welcomeCtrl',
      controllerAs: 'vm',
      resolve: {
        venues: [
          '$stateParams',
          'jsSdk.venue',
          ($stateParams, sdkVenueService) => {
            return sdkVenueService.listByOrganizationId($stateParams.organizationId, {
              fields: '_id'
            });
          }
        ]
      }
    })
    /**
     * ----------- Unauthorized -----------
     */
    .state('app.organization.unauthorized', {
      url: '/unauthorized?redirectState&redirectParams',
      template: unauthorizedTemplate,
      controller: 'unauthorizedCtrl',
      controllerAs: 'unauthorized',
      authenticate: true
    })
    /**
     * ----------- Account routes -----------
     */
    .state('app.organization.account', {
      url: '/account',
      template: accountTemplate,
      controller: 'accountCtrl',
      authenticate: true
    })
    .state('app.organization.account.profile', {
      url: '/profile',
      template: accountProfileTemplate,
      controller: 'accountProfileCtrl',
      authenticate: true
    })
    /**
     * ----------- Performance routes -----------
     */
    .state('app.organization.performance', {
      url: '/performance?start&end&venueId',
      template: performanceTemplate,
      controller: 'performanceCtrl',
      authenticate: true
    })
    .state('app.organization.performance.unauthorized', { //unauthorized route for Team section
      url: '/unauthorized?redirectState&redirectParams',
      template: unauthorizedTemplate,
      controller: 'unauthorizedCtrl',
      controllerAs: 'unauthorized',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PERFORMANCE
      }
    })
    .state('app.organization.performance.reservations', {
      url: '/reservations',
      template: performanceReservationsTemplate,
      controller: 'performanceReservationsCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PERFORMANCE,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToChildUnauthorized('app.organization.performance.unauthorized')
        }
      }
    })
    .state('app.organization.performance.guestlist', {
      url: '/guest-list',
      template: performanceGuestListTemplate,
      controller: 'performanceGuestListCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PERFORMANCE,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToChildUnauthorized('app.organization.performance.unauthorized')
        }
      }
    })
    .state('app.organization.performance.payouts', {
      url: '/payouts',
      template: performancePayoutsTemplate,
      controller: 'performancePayoutsCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PERFORMANCE,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToChildUnauthorized('app.organization.performance.unauthorized')
        }
      }
    })
    .state('app.organization.performance.payoutTransactions', {
      url: '/payouts/:payoutId/transactions',
      template: performancePayoutTransactionsTemplate,
      controller: 'performancePayoutTransactionsCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PERFORMANCE,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToChildUnauthorized('app.organization.performance.unauthorized')
        }
      }
    })
    .state('app.organization.performance.tally', {
      url: '/tally',
      template: performanceTallyTemplate,
      controller: 'performanceTallyCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PERFORMANCE,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToChildUnauthorized('app.organization.performance.unauthorized')
        }
      }
    })
    .state('app.organization.performance.exportList', {
      url: '/data-exports?downloadId',
      template: performanceExportListTemplate,
      controller: 'performanceExportListCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PERFORMANCE,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToChildUnauthorized('app.organization.performance.unauthorized')
        }
      }
    })
    /**
     * ----------- Manage routes -----------
     */
    .state('app.organization.manage', {
      url: '/manage?eventId&date&venueId&admissionGroupId',
      template: manageTemplate,
      controller: 'manageCtrl',
      abstract: true,
      authenticate: true
    })
    .state('app.organization.manage.unauthorized', { //unauthorized route for Manage section
      url: '/unauthorized?redirectState&redirectParams',
      template: unauthorizedTemplate,
      controller: 'unauthorizedCtrl',
      controllerAs: 'unauthorized',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE
      }
    })
    .state('app.organization.manage.dashboard', {
      url: '/dashboard',
      template: manageDashboard,
      controller: 'manageDashboardCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToChildUnauthorized('app.organization.manage.unauthorized')
        }
      }
    })
    .state('app.organization.manage.daySettings', {
      url: '/day-settings',
      template: manageDaySettingsTemplate,
      controller: 'manageDaySettingsCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToChildUnauthorized('app.organization.manage.unauthorized')
        }
      }
    })
    .state('app.organization.manage.reservations', {
      url: '/reservations?viewType',
      template: manageReservationsTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
        permissions: {
          only: ['canReadVenueAndCanReadReservations'],
          redirectTo: redirectToChildUnauthorized('app.organization.manage.unauthorized')
        }
      }
    })
    .state('app.organization.manage.guestlists', {
      url: '/guestlists',
      template: manageGuestlistsTemplate,
      controller: 'manageGuestlistsCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
        permissions: {
          only: ['canReadVenueAndCanReadGuestlists'],
          redirectTo: redirectToChildUnauthorized('app.organization.manage.unauthorized')
        }
      }
    })
    .state('app.organization.manage.inventory', {
      url: '/inventory',
      template: manageInventoryTemplate,
      controller: 'manageInventoryCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
        permissions: {
          only: ['canReadVenue'],
          redirectTo: redirectToChildUnauthorized('app.organization.manage.unauthorized')
        }
      }
    })
    .state('app.organization.manage.notes', {
      url: '/notes',
      template: manageNotesTemplate,
      controller: 'manageNotesCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
        permissions: {
          only: ['canReadVenue'],
          redirectTo: redirectToChildUnauthorized('app.organization.manage.unauthorized')
        }
      }
    })
    .state('app.organization.manage.exportList', {
      url: '/reservations/data-export',
      template: manageExportListTemplate,
      controller: 'manageExportListCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
        permissions: {
          only: ['canReadVenueAndCanReadReservations'],
          redirectTo: redirectToChildUnauthorized('app.organization.manage.unauthorized')
        }
      }
    })
    // .state('app.organization.eventStats', {
    //   url: '/event-stats/:eventId?venueId',
    //   template: eventStatsTemplate,
    //   authenticate: true,
    //   reloadOnSearch: false,
    //   data: {
    //     SIDEBAR_LINK: SIDEBAR_LINKS.MANAGE,
    //     permissions: {
    //       only: ['canReadPerformanceReports'],
    //       redirectTo: redirectToUnauthorized
    //     }
    //   }
    // })
    /**
     * ----------- Events routes -----------
     */
    .state('app.organization.events', {
      url: '/events?venueId',
      template: eventsTemplate,
      controller: 'eventsCtrl',
      controllerAs: 'vm',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS
      }
    })
    .state('app.organization.createEvent', {
      url: '/venue/:venueId/event/create?date',
      template: createEventTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS,
        permissions: {
          only: ['canWriteEvents'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.event', {
      url: '/venue/:venueId/event/:eventId',
      template: eventTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS,
        permissions: {
          only: ['canReadEvents'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.event.settings', {
      url: '/edit',
      template: eventSettingsTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS,
        permissions: {
          only: ['canWriteEvents'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.event.dashboard', {
      url: '/dashboard',
      template: eventDashboardTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS,
        permissions: {
          only: ['canReadEvents'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.event.widgets', {
      url: '/widgets',
      template: eventWidgetsTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS,
        permissions: {
          only: ['canReadEvents'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.event.widget', {
      url: '/widget?type',
      template: eventWidgetTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS,
        permissions: {
          only: ['canReadEvents'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.event.promoterLinks', {
      url: '/:eventId/promoter-links',
      template: eventPromotersLinksTemplate,
      controller: 'eventPromoterLinksCtrl',
      reloadOnSearch: false,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.EVENTS,
        permissions: {
          only: ['canReadEvents'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    /**
     * ----------- Customer Database -----------
     */
    .state('app.organization.customerDatabase', {
      url: '/customers',
      template: customerDatabaseTemplate,
      controller: 'customerDatabaseCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.CRM,
        permissions: {
          only: ['canReadOrganizationAndCanManageCustomers'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.customerExportList', {
      url: '/customers/data-exports?downloadId',
      template: customerDataExportsTemplate,
      controller: 'customerDataExportsCtrl',
      authenticate: true,
      data: {
        permissions: {
          only: ['canReadOrganizationAndCanExportCustomers'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.customerProfile', {
      url: '/customers/profile/:id',
      template: customerProfileTemplate,
      controller: 'customerProfileCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.CRM,
        permissions: {
          only: ['canReadOrganizationAndCanManageCustomers'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.customerEdit', {
      url: '/customers/:id?section',
      template: customerEditTemplate,
      controller: 'customerEditCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.CRM,
        permissions: {
          only: ['canReadOrganizationAndCanManageCustomers'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    /**
     * ----------- Settings routes -----------
     */
    .state('app.organization.settings', {
      url: '/settings',
      template: settingsTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.organization', {
      url: '/company',
      template: settingsOrganizationTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.attributions', {
      url: '/attributions',
      template: settingsAttributionsTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.microSiteConfigs', {
      url: '/micro-sites',
      template: settingsMicroSiteConfigsTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.microSiteConfigEdit', {
      url: '/micro-sites/:id',
      template: settingsMicroSiteConfigEditTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganization'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.integrations', {
      url: '/integrations',
      template: settingsIntegrationsTemplate,
      controller: 'settingsIntegrationsCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteOrganization'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.staff', {
      url: '/staff',
      template: settingsStaffTemplate,
      controller: 'settingsStaffCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganizationAndCanManageStaff'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.servers', {
      url: '/servers',
      template: settingsServersTemplate,
      controller: 'settingsServersCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganizationAndCanManageStaff'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.promoters', {
      url: '/external',
      template: settingsPromotersTemplate,
      controller: 'settingsPromotersCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganizationAndCanManageStaff'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue', {
      url: '/venue/:venueId',
      template: settingsVenueTemplate,
      controller: 'settingsVenueCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue.settings', {
      url: '/settings',
      template: settingsVenueSettingsTemplate,
      controller: 'settingsVenueSettingsCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue.billing', {
      url: '/billing?accountLocked&stripeUserId',
      template: settingsVenueBillingTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteOrganization'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue.businesshours', {
      url: '/business-hours',
      template: settingsVenueBusinessHoursTemplate,
      controller: 'settingsVenueBusinessHoursCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue.floorplans', {
      url: '/floorplans',
      template: settingsVenueFloorplansTemplate,
      controller: 'settingsVenueFloorplansCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue.widget', {
      url: '/widget?type',
      template: settingsVenueWidgetTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue.schedule', {
      url: '/schedule',
      template: settingsVenueScheduleInventoryTemplate,
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    .state('app.organization.settings.venue.reportSchedule', {
      url: '/report-schedule',
      template: settingsVenueReportScheduleTemplate,
      controller: 'settingsVenueReportScheduleCtrl',
      data: {
        permissions: {
          only: ['canWriteVenue'],
          redirectTo: redirectToUnauthorized
        }
      }
    })
    //old team route
    .state('app.organization.team', {
      url: '/team',
      template: teamTemplate,
      controller: 'teamCtrl',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('app.organization.team.unauthorized', {
      url: '/unauthorized?redirectState&redirectParams',
      template: unauthorizedTemplate,
      controller: 'unauthorizedCtrl',
      controllerAs: 'unauthorized',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS
      }
    })
    .state('app.organization.team.staffEdit', {
      url: '/staff/:id',
      template: teamStaffEditTemplate,
      controller: 'teamStaffEditCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganizationAndCanManageStaff'],
          redirectTo: redirectToChildUnauthorized('app.organization.team.unauthorized')
        }
      }
    })
    .state('app.organization.team.serverEdit', {
      url: '/server/:id',
      template: teamServerEditTemplate,
      controller: 'teamServerEditCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganizationAndCanManageStaff'],
          redirectTo: redirectToChildUnauthorized('app.organization.team.unauthorized')
        }
      }
    })
    .state('app.organization.team.externalEdit', {
      url: '/external/:id',
      template: teamExternalEditTemplate,
      controller: 'teamExternalEditCtrl',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.SETTINGS,
        permissions: {
          only: ['canReadOrganizationAndCanManageStaff'],
          redirectTo: redirectToChildUnauthorized('app.organization.team.unauthorized')
        }
      }
    })
    //PROMOTER ROUTES
    //promoterEventsTemplate
    .state('app.organization.promoter', {
      url: '/promoter',
      template: '<ui-view>',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PROMOTER_PROMOTE
      }
    })
    .state('app.organization.promoter.events', {
      url: '/events?venueId',
      template: promoterEventsTemplate,
      controller: 'promoterEventsCtrl',
      controllerAs: 'vm',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PROMOTER_PROMOTE
      }
    })
    .state('app.organization.promoter.sales', {
      url: '/sales?eventId&date&venueId&admissionGroupId',
      template: promoterSalesTemplate,
      controller: 'promoterSalesCtrl',
      controllerAs: 'vm',
      authenticate: true,
      abstract: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PROMOTER_SALES
      }
    })
    .state('app.organization.promoter.sales.reservations', {
      url: '/reservations',
      template: promoterSalesReservationsTemplate,
      controller: 'promoterSalesReservationsCtrl',
      controllerAs: 'vm',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PROMOTER_SALES
      }
    })
    .state('app.organization.promoter.sales.guestlists', {
      url: '/guestlists',
      template: promoterSalesGuestlistsTemplate,
      controller: 'promoterSalesGuestlistsCtrl',
      controllerAs: 'vm',
      authenticate: true,
      data: {
        SIDEBAR_LINK: SIDEBAR_LINKS.PROMOTER_SALES
      }
    });
}

function redirectToUnauthorized(rejectedPermission, transitionProperties) {
  return {
    state: 'app.organization.unauthorized',
    params: {
      organizationId: transitionProperties.toParams.organizationId,
      redirectState: transitionProperties.toParams.name,
      redirectParams: angular.toJson(transitionProperties.toParams)
    },
    options: {
      reload: true
    }
  };
}

function redirectToLogin() {
  return {
    state: 'login',
    options: {
      reload: true
    }
  };
}

function redirectToChildUnauthorized(childState) {
  return function(rejectedPermission, transitionProperties) {
    return {
      state: childState,
      params: {
        date: transitionProperties.toParams.date,
        venueId: transitionProperties.toParams.venueId,
        organizationId: transitionProperties.toParams.organizationId
      },
      options: {
        reload: true
      }
    };
  };
}

function RouterConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  if (window.history && window.history.pushState) {
    $locationProvider.html5Mode(true);
  }

  $urlRouterProvider.when('', '/');

  $urlRouterProvider.when('/', [
    '$state',
    ($state) => {
      $state.transitionTo('app.selectOrganization', {
        autoSelect: true
      });
    }
  ]);

  $urlRouterProvider.otherwise(($injector) => {
    const sdkAuthService = $injector.get('jsSdk.auth');

    if (sdkAuthService.isLoggedIn()) {
      return '/404';
    }

    return '/login';
  });

  configureRoutes($stateProvider);
}

RouterConfig.$inject = [
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider'
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/routerConfig.js